import Store from 'lightningjs-redux';

import { getCookies, areGdprCookiesSet } from '../../../logic/user/user.selectors';

const mapControllers = instance => ({
  cookies: {
    selector: getCookies,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.cookies = value;
    },
  },
  areUserPreferencesSet: {
    selector: areGdprCookiesSet,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.areGdprCookiesSet = value;
    },
  },
});

export default Store.control(mapControllers);
